<template>
  <div class="report-component">
    <ion-row class="bottom no-border">
      <ion-segment
        :value="value"
        @ionChange="$emit('onValueChange', $event.detail.value)"
        mode="ios"
      >
        <ion-segment-button
          v-for="(value, displayable) in booleanValues"
          :key="value + displayable"
          class="width-segment-form-driver"
          :value="value"
          :disabled="disabled"
        >
          <ion-label class="fs-12">{{ displayable }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ion-row>
  </div>
</template>

<script>
import { IonLabel, IonRow, IonSegment, IonSegmentButton } from '@ionic/vue';

export default {
  name: 'Date',

  components: {
    IonSegment,
    IonSegmentButton,
    IonRow,
    IonLabel,
  },

  props: {
    title: String,
    value: String,
    disabled: Boolean,
    removeNullOption: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['onValueChange'],

  data() {
    return {
      booleanValues: null,
    };
  },

  mounted() {
    this.booleanValues = {
      Oui: true,
      Non: false,
    };

    if (!this.removeNullOption) {
      this.booleanValues['Pas concerné'] = null;
    }
  },
};
</script>

<style scoped lang="scss">
ion-row {
  margin-top: 8px;
}
</style>
